<template>
  <div class="row" :class="{ 'svg-fill': props.svgFill }">
    <div class="item" v-for="item in props.values" v-show="item.value">
      <div class="icon" v-html="item.icon"></div>
      <div class="value">{{ item.prefix }}{{ item.value }}{{ item.label }}</div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  values: Array,
  svgFill: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px;
  opacity: 0.7;
  font-size: 1.3rem;
  letter-spacing: 0.13px;
}

.item {
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 100%;
  max-width: 100%;

  .value {
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 90%;
    display: block;
    padding-top: 3px;
    overflow: hidden;
  }

  :deep(svg) {
    width: 15px;
    height: 15px;
    display: block;
    position: relative;
    top: -1px;
    * {
      stroke: var(--Text, #000);
    }
  }

  .svg-fill & :deep(svg) {
    * {
      fill: var(--Text, #000);
      stroke: transparent;
    }
  }
}
</style>
